import type { Client } from '@zg-rentals/http-client';
import { createClient } from '@zg-rentals/http-client';
import { makeModuleInstance } from '@zg-rentals/util';

export const { get: getClient, set: setClient } = makeModuleInstance<Client | undefined>(undefined);
export { createClient };
